export function createWhatsappLink(message: string) {
  const encodedMessage = encodeURIComponent(message);

  return `https://wa.me/5548936180235?text=${encodedMessage}`;
}
